import { useEffect, useState } from "react";

const EVT = "mfc-list-change";
const read = (key) => { try { return JSON.parse(localStorage.getItem(key) || "[]"); } catch { return []; } };

export const SHORTLIST_KEY = "mfc_shortlist";
export const COMPARE_KEY = "mfc_compare";

// Small localStorage-backed id list shared across components (no login needed).
export const useIdList = (key, max = 100) => {
  const [ids, setIds] = useState(() => read(key));
  useEffect(() => {
    const sync = (e) => { if (!e.detail || e.detail === key) setIds(read(key)); };
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener("storage", sync); };
  }, [key]);
  const save = (next) => { localStorage.setItem(key, JSON.stringify(next)); window.dispatchEvent(new CustomEvent(EVT, { detail: key })); };
  const toggle = (id) => {
    const cur = read(key);
    if (cur.includes(id)) { save(cur.filter((x) => x !== id)); return true; }
    if (cur.length >= max) return false;
    save([...cur, id]);
    return true;
  };
  return { ids, has: (id) => ids.includes(id), toggle, clear: () => save([]) };
};
